import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, ownerOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="text-sm text-[var(--ink-muted)] font-mono-num" data-testid="auth-loading">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (!user.is_active || user.role === "pending") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] p-8">
        <div className="max-w-md text-center border border-[var(--border)] bg-white p-10">
          <h1 className="font-display text-2xl font-black mb-3">Acceso pendiente</h1>
          <p className="text-sm text-[var(--ink-muted)] mb-6">
            Tu cuenta <span className="font-mono-num text-[var(--ink)]">{user.email}</span> está pendiente de aprobación
            por un administrador.
          </p>
          <a href="/login" className="inline-block bg-black text-white px-4 py-2 text-sm" data-testid="pending-back-login">Volver al inicio</a>
        </div>
      </div>
    );
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  if (ownerOnly && (user.email || "").toLowerCase() !== "eduardo@grabarte360.com") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
